import { Reference } from '../reference';

export class JobReference extends Reference {
  organization?: string;
  createdAt?: string;
  destination?: string;
  haulRate?: string;
  invoiceRate?: string;
  jobCode?: string;
  jobName?: string;
  material?: string;
  origin?: string;
  orderNumber?: string;
  display = 'Job Reference';
  // eslint-disable-next-line @typescript-eslint/member-ordering
  [key: string]: any;
}
